import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { AuthService } from './auth.services';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  activeRequests: number = 0;
  constructor(public auth: AuthService, private spinner: NgxSpinnerService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //if (this.activeRequests === 0) {
    this.spinner.show();
    this.activeRequests++;
    //}
    if (
      request.headers.get('content-type') !==
      'application/x-www-form-urlencoded'
    ) {
      if (
        request.url.match('/assets/i18n/') !== null &&
        request.url.match('/assets/i18n/').length >= 1
      ) {
        this.spinner.hide();
        return next.handle(request);
      } else {
        if (
          request.url.match('forgetpassword') == null &&
          request.url.match('changePassword') == null
        ) {
          const token = this.auth.getToken();
          const authReq = request.clone({
            headers: request.headers.set(
              'Authorization',
              'Bearer ' + token.access_token
            )
          });
          return next
            .handle(authReq)
            .map((event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) {
                this.spinner.hide();
              }
              //this.activeRequests--;
              //if (this.activeRequests === 0) {
              //this.spinner.hide();
              //}
              return event;
            })
            .catch((err: any, caught) => {
              if (err instanceof HttpErrorResponse) {
                this.spinner.hide();
                if (err.status === 401 || err.status === 500) {

                  this.auth.logout();

                }
                return Observable.throw(err);
              }
            });
        } else {
          this.spinner.hide();
          return next.handle(request);
        }
      }
    } else {
      return next
        .handle(request)
        .map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.spinner.hide();
          }
          this.activeRequests--;
          //if (this.activeRequests === 0) {
          //this.spinner.hide();
          //}
          return event;
        })
        .catch((err: any, caught) => {
          if (err instanceof HttpErrorResponse) {
            this.spinner.hide();
            if (err.status === 401 || err.status === 500) {

              this.auth.logout();
            }
            return Observable.throw(err);
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/token.interceptors.ts